import { render, staticRenderFns } from "./NumberInputConfig.vue?vue&type=template&id=bb4e78be&scoped=true&"
import script from "./NumberInputConfig.vue?vue&type=script&lang=js&"
export * from "./NumberInputConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4e78be",
  null
  
)

export default component.exports